// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + chunkId + "-" + {"7107": "1fbfdf1b146b2721","8106": "0c0e5babab4f0401",}[chunkId] + ".chunk.js"
}